<template>
  <div>
    <div class="read_center_box" id="read_center_box">
      <div class="read_top">
        <div class="dqyd">
          <img src="@/assets/icon/read_ico_sj.png" /> 您已阅读{{
            readingTimeCount | stohms
          }}<!-- 1小时23分钟54秒 -->
        </div>
        <div class="bookmarks">
          <img
            @click="bookmarksBtn('add')"
            v-show="JSON.stringify(bookmarkList).indexOf(currentCfi) === -1"
            src="@/assets/icon/bookmark_03.png"
            alt=""
          />
          <img
            @click="bookmarksBtn('delete')"
            v-show="JSON.stringify(bookmarkList).indexOf(currentCfi) !== -1"
            src="@/assets/icon/bookmark_04.png"
            alt=""
          />
        </div>
      </div>
      <!--  中间分割线 -->
      <!-- <div id="divider" class="show" v-show="flow === 'auto'"></div>  -->
      <div id="box" v-show="boxViewer">
        <div id="viewer" class="scrolled"></div>
      </div>
    </div>
    <div class="read_right_box">
      <div class="read_right_box1">
        <el-popover
          placement="left"
          width="500"
          trigger="click"
          v-model="searchVisible"
        >
          <i
            class="el-icon-error"
            style="
              float: right;
              margin-top: -5px;
              margin-bottom: 5px;
              cursor: pointer;
            "
            @click="searchVisible = false"
          ></i>
          <div class="mulu rmulu">
            <div>
              <div class="custom-search" style="border: none">
                <input
                  type="text"
                  class="custom-input"
                  placeholder="请输入"
                  v-model.trim="searchInput"
                  @keyup.enter="xsearch(searchInput)"
                />
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  class="custom-button"
                  @click="xsearch(searchInput)"
                  >搜索
                </el-button>
              </div>
              <!-- <div class="search_row">
                <el-input
                  v-model="searchInput"
                  placeholder="请输入内容"
                  @change="xsearch(searchInput)"
                ></el-input>
                <div class="searchbox" @click="xsearch(searchInput)">
                  <i class="el-icon-search"></i>搜索
                </div>
              </div> -->
              <div v-for="(item, index) in searchList" :key="index">
                <div
                  v-show="
                    index > 0
                      ? item.excerpt != searchList[index - 1].excerpt
                      : true
                  "
                  class="searchList_box"
                  v-html="item.excerpt"
                  @click="searchcfi(item)"
                ></div>
              </div>
            </div>
          </div>
          <li slot="reference">
            <img
              v-if="backclass !== 'zt_heise'"
              src="@/assets/icon/search.png"
            />
            <img
              v-if="backclass === 'zt_heise'"
              src="@/assets/icon/search.png"
            />
            <p>搜索</p>
          </li>
        </el-popover>
        <el-popover
          placement="left"
          width="500"
          trigger="click"
          v-model="muluvisible"
        >
          <i
            class="el-icon-error"
            style="
              float: right;
              margin-top: -5px;
              margin-bottom: 5px;
              cursor: pointer;
            "
            @click="muluvisible = false"
          ></i>
          <xmlTree :mulu="mulu" @clickmulu="clickmulu" />
          <!-- <div class="mulu rmulu">
            <li v-for="(item, index) in mulu" :key="index">
              <p class="ellipsis-aRow" @click="clickmulu(item)">
                {{ item.label }}
              </p>
              <ul v-if="item.subitems.length" class="twomulu">
                <li
                  v-for="(item2, index2) in item.subitems"
                  :key="index2"
                  @click="clickmulu(item2)"
                >
                  {{ item2.label }}
                </li>
              </ul>
            </li>
          </div> -->
          <li slot="reference">
            <img
              v-if="backclass !== 'zt_heise'"
              src="@/assets/icon/read_ico_mulu.png"
            />
            <img
              v-if="backclass === 'zt_heise'"
              src="@/assets/icon/read_ico_mulu_bai.png"
            />
            <p>目录</p>
          </li>
        </el-popover>
        <el-popover
          placement="left"
          width="350"
          trigger="click"
          v-model="shezhivisible"
        >
          <i
            class="el-icon-error"
            style="
              float: right;
              margin-top: -5px;
              margin-bottom: 5px;
              cursor: pointer;
            "
            @click="shezhivisible = false"
          ></i>
          <div class="shezhi">
            <li>
              <p>阅读主题</p>
              <div class="xz_box ydzt">
                <span
                  v-for="(item, index) in backgroundList"
                  :key="index"
                  :class="item.backclass === backclass ? 'active' : ''"
                  :style="'background: ' + item.color"
                  @click="changezt(item), result(), shezhisave()"
                ></span>
              </div>
            </li>
            <li>
              <p>正文字体</p>
              <div class="xz_box zwzt">
                <span
                  @click="changezwzt(item.value), shezhisave()"
                  :class="zwzt === item.value ? 'active' : ''"
                  v-for="(item, index) in zwztList"
                  :key="index"
                  >{{ item.label }}</span
                >
              </div>
            </li>
            <li>
              <p>字体大小</p>
              <div class="xz_box ztdx">
                <el-input-number
                  v-model="num"
                  @change="numchange()"
                  size="small"
                  :min="12"
                  :max="36"
                  label="描述文字"
                  :step="2"
                  step-strictly
                  @blur="
                    (e, name) => {
                      blurNumber(e, 'num');
                    }
                  "
                ></el-input-number>
              </div>
            </li>
          </div>
          <li slot="reference">
            <img
              v-if="backclass !== 'zt_heise'"
              src="@/assets/icon/read_ico_shezhi.png"
            />
            <img
              v-if="backclass === 'zt_heise'"
              src="@/assets/icon/read_ico_shezhi_bai.png"
            />
            <p>设置</p>
          </li>
        </el-popover>
        <el-popover
          placement="left"
          width="500"
          trigger="click"
          v-model="bijivisible"
        >
          <i
            class="el-icon-error"
            style="
              float: right;
              margin-top: -5px;
              margin-bottom: 5px;
              cursor: pointer;
            "
            @click="bijivisible = false"
          ></i>
          <div class="mulu">
            <li v-for="(item, index) in highlights" :key="index">
              <p
                style="cursor: pointer"
                @click="highlightClick(item.textRange)"
              >
                {{ item.noteContent }}
              </p>
              <div class="sjcz">
                <p style="float: left">{{ item.createTime }}</p>
                <div class="mulu_liright">
                  <span @click="updateNote(index)">
                    <i class="el-icon-edit"></i>
                    修改
                  </span>
                  <span @click="removeNote(item.textRange, index)">
                    <i class="el-icon-delete"></i>
                    删除
                  </span>
                </div>
              </div>
            </li>
            <noData v-if="highlights == 0"></noData>
          </div>
          <li slot="reference">
            <img
              v-if="backclass !== 'zt_heise'"
              src="@/assets/icon/read_ico_biji.png"
            />
            <img
              v-if="backclass === 'zt_heise'"
              src="@/assets/icon/read_ico_biji_bai.png"
            />
            <p>笔记</p>
          </li>
        </el-popover>
        <el-popover
          placement="left"
          width="500"
          trigger="click"
          v-model="bookmarkVisible"
        >
          <i
            class="el-icon-error"
            style="
              float: right;
              margin-top: -5px;
              margin-bottom: 5px;
              cursor: pointer;
            "
            @click="bookmarkVisible = false"
          ></i>
          <div class="mulu">
            <li v-for="(item, index) in bookmarkList" :key="index">
              <p
                class="bookmark-item"
                style="cursor: pointer"
                @click="highlightClick(item.textRange)"
              >
                {{ item.noteContent }}
              </p>
              <div class="sjcz">
                <p style="float: left">{{ item.createTime }}</p>
                <div class="mulu_liright">
                  <span @click="deleteBookmark(item.id)">
                    <i class="el-icon-delete"></i>
                    删除
                  </span>
                </div>
              </div>
            </li>
            <noData v-if="bookmarkList.length == 0"></noData>
          </div>
          <li slot="reference">
            <img
              v-if="backclass !== 'zt_heise'"
              src="@/assets/icon/bookmark_01.png"
            />
            <img
              v-if="backclass === 'zt_heise'"
              src="@/assets/icon/bookmark_02.png"
            />
            <p>书签</p>
          </li>
        </el-popover>
        <li
          :class="
            this.$route.query.typeName == 0 && isBookshelf === true
              ? 'cursorDefault'
              : ''
          "
          @click="addBookshelf()"
        >
          <img
            v-if="backclass !== 'zt_heise'"
            src="@/assets/icon/read_ico_shujia.png"
          />
          <img
            v-if="backclass === 'zt_heise'"
            src="@/assets/icon/read_ico_shujia_bai.png"
          />
          <p v-if="isBookshelf">已加书架</p>
          <p v-if="!isBookshelf">加入书架</p>
        </li>
        <li @click="changeflow">
          <div v-if="backclass !== 'zt_heise'">
            <img
              v-if="flow === 'auto'"
              src="@/assets/icon/read_ico_huadong.png"
            />
            <img
              v-if="flow !== 'auto'"
              src="@/assets/icon/read_ico_fanye.png"
            />
          </div>
          <div v-if="backclass === 'zt_heise'">
            <img
              v-if="flow === 'auto'"
              src="@/assets/icon/read_ico_huadong_bai.png"
            />
            <img
              v-if="flow !== 'auto'"
              src="@/assets/icon/read_ico_fanye_bai.png"
            />
          </div>
          <p>{{ flow === "auto" ? "滑动阅读" : "翻页阅读" }}</p>
        </li>
      </div>
      <div class="read_right_box2">
        <div id="prev">
          <img @click="prevPage()" src="@/assets/icon/read_ico_shang.png" />
        </div>
        <div id="next">
          <img @click="nextPage()" src="@/assets/icon/read_ico_xia.png" />
        </div>
      </div>
    </div>
    <div class="slider_box">
      <el-slider
        id="slider"
        v-model="progress"
        @change="onProgressChange"
        :max="sliderMax"
        :format-tooltip="sliderFormat"
        :show-tooltip="flag"
      >
      </el-slider>
    </div>

    <div
      v-show="showAddNotes"
      :style="{
        top: topDistance + 'px',
        left: 'calc(50% + 50px)',
      }"
      class="add-notes-bookmarks-pc"
    >
      <div class="item-box">
        <img
          @click.stop="notesBtn()"
          src="@/assets/icon/notes_icon.png"
          alt=""
        />
        <span>笔记</span>
      </div>
      <div class="item-box">
        <img
          @click.stop="lineationBtn()"
          src="@/assets/icon/bookmarks_icon.png"
          alt=""
        />
        <span>划线</span>
      </div>
    </div>
  </div>
</template>

<script>
import "jszip";
import Epub from "epubjs";
import { ImagePreview } from "vant";
import {
  insertNote,
  update,
  selectNoteListByFileId,
  removeNoteById,
  selectFileLinkAndReadingLocation, //查看阅读文件地址和文件进度
  selectReadInfo, //获取阅读时长
  selectTimeParameter, //获取调用阅读时长接口频率
  updateOcDownloadReading, //更新用户阅读时长
  updateOcReadSchedule, //更新阅读进度
} from "@/api/special/special";
import {
  IsBookshelfAdd,
  BookshelfAdd,
  delBookshelf,
  SelGoodsStatus,
} from "@/api/bookstore/bookstore";
import { checkIsBuy, isHavingPermissions } from "@/api/bookstore/bookstore";
import noData from "@/components/noData.vue";
import xmlTree from "./xmlTree.vue";
export default {
  components: {
    noData,
    xmlTree,
  },
  data() {
    return {
      showAddNotes: false,
      topDistance: 160,
      leftpDistance: 200,
      searchList: [],
      loading: false,
      goodsId: this.$route.query.goodsId, //需要传递的参数
      filesId: "", //需要传递的参数(资源文件id)
      goodsFilePath: "", //需要传递的参数(资源文件路径)
      book: {},
      rendition: [],
      highlights: [],
      bookmarkList: [],
      note: {},
      displayed: {},
      bijivisible: false,
      muluvisible: false,
      searchVisible: false,
      shezhivisible: false,
      flag: true,
      isRTL: true,
      chapterName: "",
      readingLocation: "",
      readTime: "",
      progress: 0,
      flow: "scrolled", //scrolled=>竖版   auto=>横版
      mulu: undefined, //目录
      num: 16, //字体
      locations: {},
      backclass: "zt_moren", //主题的背景颜色class
      backgroundList: [
        {
          backclass: "zt_moren",
          color: "#f8f4e9",
        },
        {
          backclass: "zt_niupizhi",
          color: "#dbcfa5",
        },
        {
          backclass: "zt_danlvse",
          color: "#ebf1e5",
        },
        {
          backclass: "zt_danlanse",
          color: "#e9f5f5",
        },
        {
          backclass: "zt_danfense",
          color: "#f4e9e9",
        },
        {
          backclass: "zt_huise",
          color: "#e6e2e2",
        },
        {
          backclass: "zt_heise",
          color: "#424242",
        },
      ],
      sliderMax: 100, //进度条默认最大值
      sliderList: [], //slider数据
      zwzt: "'Microsoft YaHei',PingFangSC-Regular,HelveticaNeue-Light,'Helvetica Neue Light',sans-serif", //字体
      zwztList: [
        {
          value:
            "'Microsoft YaHei',PingFangSC-Regular,HelveticaNeue-Light,'Helvetica Neue Light',sans-serif",
          label: "雅黑",
        },
        {
          value: "STKaiti,Kaiti",
          label: "楷书",
        },
      ], //字体列表
      bookdetail: {}, //基本信息
      sourceList: [], //文件信息
      readdefault: 0, //默认阅读第一个
      // buystatus:'1',//购买状态0=》已购买随便读  1=》未购买只能读免费
      TimeParameter: 10, //更新频次-单位分钟
      readingTimeCount: 0, //阅读时间-单位秒
      setInterval2: undefined,
      setInterval1: undefined,
      isBookshelf: false,
      cfiRange: "", //划中的选区地址 ，用selected事件来获取暂存到此参数，mouseup事件时使用
      Trial: false,
      boxViewer: true,
      searchInput: "",
      bookmarkVisible: false,
      range: null,
      contents: null,
      currentCfi: "",
      operationalState: 0,
    };
  },
  watch: {
    //监听路由变化
    $route() {
      if (this.$route.query.goodsId) {
      }
    },
  },
  created() {
    if (this.$route.query.isTrial == "true") {
      this.Trial = true;
    } else {
      this.Trial = false;
    }
  },
  destroyed() {
    this.closeTime();
  },
  methods: {
    searchcfi(e) {
      this.rendition.display(e.cfi);
      this.searchVisible = false;
      this.searchInput = "";
      this.searchList = [];
    },
    xdoSearch(q) {
      return Promise.all(
        this.book.spine.spineItems.map((item) =>
          item
            .load(this.book.load.bind(this.book))
            .then(item.find.bind(item, q))
            .finally(item.unload.bind(item))
        )
      ).then((results) => Promise.resolve([].concat.apply([], results)));
    },
    xsearch(q) {
      if (q == "") {
        return this.$message("搜索内容不能为空");
      }
      this.xdoSearch(q).then((result) => {
        let searchList = result.map((item) => {
          item.excerpt = item.excerpt.replace(
            q,
            `<span class="content-search-text" style="color: #2e9adb;
             font-size: 13px;
             font-family: PingFang SC;
             font-weight: 400;">${q}</span>`
          );
          return item;
        });
        this.searchList = searchList;
        console.log(this.searchList);
      });
    },
    tabbook(item, index) {
      this.Trial = false; //试读
      this.IsBookshelfAdd();
      if (localStorage.getItem("shezhisave")) {
        var newshezhi = JSON.parse(localStorage.getItem("shezhisave"));
        this.num = newshezhi.num;
        this.zwzt = newshezhi.zwzt;
        this.backclass = newshezhi.backclass;
        this.$store.state.read.backclass = newshezhi.backclass;
      }
      selectFileLinkAndReadingLocation({
        goodsFileId: item.filesId, //goodsFileId没有，谢萌说可用filesId
        fileType: item.fileType,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => {
        let data = res.data;
        if (data) {
          this.buys(item, index, data);
        }
      });
    },
    buys(item, index, data) {
      //判断是否购买该商品
      this.payType = this.$route.query.payType
        ? this.$route.query.payType
        : "goods";
      checkIsBuy({
        relevanceId: this.goodsId,
        type: this.payType,
      }).then((res) => {
        if (data.hasPermission) {
          //有权限
          this.readdefault = index;
          this.boxViewer = true;
          this.goodsFilePath = data.filePath;
          this.initbook(item, index, data.readingLocation); //加载阅读方法并且跳转到阅读位置  readingLocation为阅读位置标记
          this.selectTimeParameter(); //获取更新进度和时长的频次   循环调用更新时长和更新进度方法
        } else if (res.data == "1" && item.sourceStatus == "2") {
          this.Trial = true; //试读
          this.boxViewer = true;
          this.goodsFilePath = data.filePath;
          this.initbook(item, index, data.readingLocation); //加载阅读方法并且跳转到阅读位置  readingLocation为阅读位置标记
        } else {
          //无权限
          this.goodsFilePath = "";
          this.boxViewer = false;
          this.checkIsBuys();
        }
      });
    },

    checkIsBuys() {
      //无权限走购买流程
      let title = "";
      if (this.Trial == false) {
        title = "该文件需要购买后才能阅读，是否确认购买";
      } else {
        title = "购买后可继续阅读";
      }
      this.$alert(`${title}`, "购买", {
        confirmButtonText: "立即购买",
        callback: (action) => {
          if (action === "cancel") {
            return;
          }
          let userId = this.$store.getters.userId;
          if (!userId) {
            this.$store.commit("SET_REDIRECTPARAMS", {
              goodsId: this.$route.query.goodsId,
              relevanceId: this.$route.query.relevanceId,
              resource: this.$route.query.resource,
              resourceType: this.$route.query.resourceType,
            });
            this.$router.push({
              path: "/login",
              query: {
                redirectPath: "/onlineReading",
              },
            });
          } else {
            //判断是否购买该商品
            this.payType = this.$route.query.payType
              ? this.$route.query.payType
              : "goods";
            checkIsBuy({
              relevanceId: this.goodsId,
              type: this.payType,
            }).then((res) => {
              if (res.data === "2") {
                this.$message.error("数据异常");
                return;
              }
              if (res.data === "1") {
                this.$router.push({
                  path: "/submitOrder/index",
                  query: {
                    id: this.$route.query.goodsId,
                    from: "bookstore",
                  },
                });
              } else {
                this.$message("该商品已购买无需重复购买");
              }
            });
          }
        },
      });
    },
    IsBookshelfAdd() {
      //判断是否加入书架
      IsBookshelfAdd({
        goodsId: this.$route.query.goodsId,
        type: this.$route.query.resourceType,
      }).then((res) => {
        if (res.code == 200) {
          this.isBookshelf = res.data;
        }
      });
    },
    blurNumber(e, name) {
      if (!e.target.value) {
        this.num = 12;
      }
    },
    selectTimeParameter() {
      //获取更新 时长和进度 的频次
      selectTimeParameter().then((res) => {
        this.TimeParameter = res.data;

        this.setInterval2 = setInterval(() => {
          this.operationalState++;
          if (this.operationalState < 60) {
            this.updateOcDownloadReading(); //更新阅读时长
            this.updateOcReadSchedule(); //更新阅读时长
          }
        }, this.TimeParameter * 60000);
      });
    },
    selectReadInfo() {
      //获取阅读时长
      selectReadInfo({
        filesId: this.filesId,
      }).then((res) => {
        if (res.data === null) {
          this.readingTimeCount = 0;
        } else {
          this.readingTimeCount = res.data.readingTimeCount * 60;
        }
        this.setInterval1 = setInterval(() => {
          this.readingTimeCount++;
        }, 1000);
      });
    },
    closeTime() {
      clearInterval(this.setInterval1);
      clearInterval(this.setInterval2);
      this.setInterval1 = null;
      this.setInterval2 = null;
    },
    updateOcDownloadReading() {
      //更新用户阅读时长接口
      updateOcDownloadReading({
        goodsFileId: this.filesId,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => {});
    },
    updateOcReadSchedule() {
      //更新阅读进度
      const percentage = this.progress / 100;
      const location =
        percentage > 0 ? this.locations.cfiFromPercentage(percentage) : 0;
      updateOcReadSchedule({
        fileId: this.filesId,
        readingLocation: location,
        schedule: (percentage * 100).toFixed(1),
      }).then((res) => {});
    },
    initbook(item, index, readingLocation) {
      //加载epub方法，readingLocation=>阅读位置
      document.getElementById("viewer").remove();
      var dom = document.createElement("div");
      dom.id = "viewer";
      dom.className = "scrolled";
      document.getElementById("box").appendChild(dom);
      this.progress = 0;
      this.readdefault = index;
      this.filesId = item.filesId;
      this.showEpub(readingLocation); //加载epub，传之前的阅读位置
      this.initNoteList("note"); //获取笔记
      this.initNoteList("bookmark"); //获取笔记
      this.initNoteList("lineation"); //获取笔记
      this.selectReadInfo(); //获取阅读时长接口
    },
    //进度条显示百分比
    sliderFormat(value) {
      if (value != 0) {
        value = parseFloat(value).toFixed(0) + "%";
      }
      return value;
    },
    // 电子书的解析和渲染
    showEpub(readingLocation) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      var _this = this;
      // 将epub文件路径 转为解压后的文件

      let epubFilePath =
        this.goodsFilePath.split(".epub")[0] + "/container.xml";
      // 生成book
      this.book = new Epub(epubFilePath);
      this.rendition = this.book.renderTo("viewer", {
        width: window.innerWidth - 450,
        height: window.innerHeight - 112,
        // manager: "continuous",
        flow: this.flow,
      });
      if (readingLocation) {
        this.rendition.display(readingLocation);
      } else {
        this.rendition.display();
      }
      // 使用左右键切换上下页
      this.book.ready.then(() => {
        let next = document.getElementById("next");
        let keyListener = function (e) {
          // 左键
          if ((e.keyCode || e.which) == 37) {
            _this.book.package.metadata.direction === "rtl"
              ? _this.nextPage()
              : _this.prevPage();
          }
          // 上键
          if ((e.keyCode || e.which) == 38) {
            _this.book.package.metadata.direction === "rtl"
              ? _this.nextPage()
              : _this.prevPage();
          }

          // 右键
          if ((e.keyCode || e.which) == 39) {
            _this.book.package.metadata.direction === "rtl"
              ? _this.prevPage()
              : _this.nextPage();
          }
          // 下键
          if ((e.keyCode || e.which) == 40) {
            _this.book.package.metadata.direction === "rtl"
              ? _this.prevPage()
              : _this.nextPage();
          }
        };
        _this.rendition.on("keyup", keyListener);
        document.addEventListener("keyup", keyListener, false);
      });
      this.rendition.on("relocated", function (location) {
        _this.currentCfi = location.start.cfi;
        var next =
          _this.book.package.metadata.direction === "rtl"
            ? document.getElementById("prev")
            : document.getElementById("next");
        var prev =
          _this.book.package.metadata.direction === "rtl"
            ? document.getElementById("next")
            : document.getElementById("prev");

        if (location.atEnd) {
          next.style.visibility = "hidden";
        } else {
          next.style.visibility = "visible";
        }

        if (location.atStart) {
          prev.style.visibility = "hidden";
        } else {
          prev.style.visibility = "visible";
        }
      });
      this.book.ready
        .then(() => {
          this.navigation = _this.book.navigation;
          //生成locations对象的定位符
          return _this.book.locations.generate();
        })
        .then(() => {
          //保存loactions对象
          this.locations = _this.book.locations;
          //电子书渲染完
          this.bookAvailable = true;
          setTimeout(() => {
            this.rendition.hooks.content.register((contents, view) => {
              contents.document.addEventListener("contextmenu", (e) => {
                //删除默认事件
                e.preventDefault();
                return false;
              });
            });
          }, 2000);
        });
      this.book.loaded.navigation.then(function (toc) {
        let tocLlength = toc.length;
        _this.sliderList = _this.treeToArray(
          JSON.parse(JSON.stringify(toc.toc))
        );
        _this.mulu = toc.toc;
        console.log(_this.mulu);
        setTimeout(() => {
          _this.result();
          loading.close();
        }, 1000);
      });
      this.rendition.on("selected", (cfiRange) => {
        this.cfiRange = cfiRange;
      });

      this.rendition.on("mousedown", (e) => {
        _this.operationalState = 0;
        if (_this.showAddNotes) {
          _this.showAddNotes = false;
          _this.cfiRange = "";
          _this.range = null;
        }
        if (e.srcElement.tagName === "IMG") {
          ImagePreview({ images: [e.srcElement.src], closeable: true });
        }
      });
      this.rendition.on("mouseup", (e, contents) => {
        setTimeout(() => {
          if (this.cfiRange === "") {
            return;
          }
          // this.rendition.annotations.highlight(this.cfiRange, {}, (e) => {});
          // contents.window.getSelection().removeAllRanges();
          this.contents = contents;
          this.book.getRange(this.cfiRange).then((range) => {
            _this.isRTL = false;
            this.range = range;

            if (this.range) {
              _this.showAddNotes = true;
            } else {
              contents.window.getSelection().empty();
            }
          }, 500);
        });
      });
    },
    //tree=>list
    treeToArray(list, newArr = []) {
      list.forEach((item) => {
        const { subitems } = item;
        if (subitems) {
          delete item.subitems;
          if (subitems.length) {
            newArr.push(item);
            return this.treeToArray(subitems, newArr);
          }
        }
        newArr.push(item);
      });
      return newArr;
    },
    onProgressChange(progress) {
      let pro = progress;
      if (progress > 10 && this.Trial) {
        this.$message("该商品试读结束");
        this.checkIsBuys();
        pro = 10;
      } else {
        pro = progress;
      }
      this.progress = pro;
      const percentage = pro / 100;
      //通过this.locations.cfiFromPercentage(percentage)获取到当前的页数
      const location =
        percentage > 0 ? this.locations.cfiFromPercentage(percentage) : "";
      //传入location进行定位渲染
      if (location) {
        this.rendition.display(location);
      } else {
        this.rendition.display();
      }
    },
    result() {
      this.changezt({
        backclass: this.backclass,
      });
      this.numchange();
      this.changezwzt(this.zwzt);
      var hei = this.backclass === "zt_heise" ? "#ccc" : "#000";
      this.rendition.themes.default({
        "::selection": {
          background: "rgba(255,255,0, 0.3)",
        },
        ".epubjs-hl": {
          fill: "yellow",
          "fill-opacity": "0.3",
          "mix-blend-mode": "multiply",
        },
        body: {
          background: "rgba(255,255,255, 0)",
        },
        body: {
          color: hei,
        },
        body: {
          "background-size": "100%",
        },
        body: {
          "background-image": "none",
          "background-size": "100%",
          "background-repeat": "no-repeat",
        },
        video: {
          "max-width": "90%",
        },
      });
    },
    clickmulu(item) {
      let _this = this;
      console.log('开始跳转',item);
      
      this.rendition.display(item.href).then(() => {
      console.log("currentLocation 跳转成功");
      
        const currentLocation = _this.rendition.currentLocation();
        const progress =
          Math.floor(
            _this.locations
              .percentageFromCfi(currentLocation.start.cfi)
              .toFixed(5) * 10000
          ) / 100;
        _this.progress = progress;
        if (_this.progress > 10 && this.Trial) {
          _this.progress = 10;
          this.checkIsBuys();
          const location = _this.locations.cfiFromPercentage(
            _this.progress / 100
          );
          if (location) {
            this.rendition.display(location);
          }
        }
      });
      _this.result();
      _this.muluvisible = false;
    },
    highlightClick(epubcfi) {
      let _this = this;
      setTimeout(() => {
        //点击目录获取进度，进度条滑动到指定位置
        this.rendition.display(epubcfi).then(() => {
          const currentLocation = _this.rendition.currentLocation();
          const progress =
            Math.floor(
              _this.locations
                .percentageFromCfi(currentLocation.start.cfi)
                .toFixed(5) * 10000
            ) / 100;
          _this.progress = progress;
        });
        this.result();
        this.bijivisible = false;
        this.bookmarkVisible = false;
      }, 500);
    },
    changezt(item) {
      //更换主题
      this.backclass = item.backclass;
      this.$store.state.read.backclass = item.backclass;
    },
    numchange() {
      if (this.num <= 12) {
        this.num = 12;
      } else if (this.num >= 48) {
        this.num = 48;
      }
      this.shezhisave();
      this.rendition.themes.fontSize(this.num + "px");
      this.initNoteList("note");
    },
    changezwzt(fontfamily) {
      this.zwzt = fontfamily;
      this.rendition.themes.font(this.zwzt);
    },
    updateNote(index) {
      this.isRTL = false;
      this.note = this.highlights[index];
      this.$prompt("请输入笔记内容", "提示", {
        inputValue: this.note.noteContent,
        inputType: "textarea",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        inputValidator: (value) => {
          // 点击按钮时，对文本框里面的值进行验证
          if (!value || /^\s+$/.test(value)) {
            return "请输入笔记内容";
          }
          if (value.length > 100) {
            return "不能超过100字";
          }
        },
      })
        .then(({ value }) => {
          this.note.noteContent = value;
          //修改笔记内容
          update(this.note).then((response) => {
            if (response.code == 200) {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.initNoteList("note");
              this.bijivisible = true;
              this.isRTL = true;
            }
          });
        })
        .catch(() => {
          this.isRTL = true;
        });
    },
    removeNote(epubcfi, index) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.rendition.annotations.remove(epubcfi, "highlight");
        removeNoteById(this.highlights[index].id).then((response) => {
          this.initNoteList("note");
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.bijivisible = true;
        });
        return false;
      });
    },
    shezhisave() {
      setTimeout(() => {
        var shezhisave = {
          num: this.num, //字体
          backclass: this.backclass, //主题
          zwzt: this.zwzt, //字体
        };
        localStorage.setItem("shezhisave", JSON.stringify(shezhisave));
      }, 300);
    },
    // 电子书切换到上一页
    prevPage() {
      this.operationalState = 0;
      /* let prev = this.rendition.prev();*/
      let _this = this;
      if (_this.isRTL) {
        this.rendition.prev().then(() => {
          const currentLocation = _this.rendition.currentLocation();
          const progress =
            Math.floor(
              _this.locations
                .percentageFromCfi(currentLocation.start.cfi)
                .toFixed(5) * 10000
            ) / 100;
          _this.progress = progress;
        });
      }
    },
    // 电子书切换到下一页
    nextPage() {
      this.operationalState = 0;
      let _this = this;
      const currentLocation = _this.rendition.currentLocation();
      let progress = "";
      if (currentLocation) {
        progress =
          Math.floor(
            _this.locations
              .percentageFromCfi(currentLocation.start.cfi)
              .toFixed(5) * 10000
          ) / 100;
        if (progress > 10 && this.Trial) {
          this.$message("该商品试读结束");
          this.checkIsBuys();
          return;
        }
      }
      if (_this.isRTL) {
        this.rendition.next().then(() => {
          _this.progress = progress;
        });
      }
    },
    //加入书架
    addBookshelf() {
      //判断是否登录
      let userId = this.$store.getters.userId;
      if (!userId) {
        this.$store.commit("SET_REDIRECTPARAMS", {
          goodsId: this.$route.query.goodsId,
          relevanceId: this.$route.query.relevanceId,
          resource: this.$route.query.resource,
          resourceType: this.$route.query.resourceType,
        });
        this.$router.push({
          path: "/login",
          query: {
            redirectPath: "/onlineReading",
          },
        });
      } else {
        if (!this.isBookshelf) {
          SelGoodsStatus(this.$route.query.goodsId).then((goodsState) => {
            if (goodsState.data.status === 2) {
              BookshelfAdd({
                goodsId: this.$route.query.goodsId,
                type: this.$route.query.resourceType,
              }).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    message: "加入书架成功",
                    type: "success",
                  });
                  this.isBookshelf = true;
                }
              });
            } else {
              this.$message("该商品已下架");
            }
          });
        } else {
          if (this.$route.query.typeName == 0) {
            return;
          }
          //移出书架
          delBookshelf({
            goodsId: this.$route.query.goodsId,
            type: this.$route.query.resourceType,
          }).then((res) => {
            if (res.data) {
              this.isBookshelf = false;
              this.$message({
                message: "移出书架",
                type: "success",
              });
            }
          });
        }
      }
    },
    changeflow() {
      if (this.flow === "auto") {
        this.flow = "scrolled";
      } else {
        this.flow = "auto";
      }
      setTimeout(() => {
        this.book.rendition.flow(this.flow);
        this.result();
        this.rendition.display(this.rendition.location.start.cfi);
      }, 100);
    },
    initNoteList(type) {
      //初始化笔记
      selectNoteListByFileId(this.filesId, type).then((response) => {
        if (type == "note") {
          this.highlights = response.data;
          for (let item of response.data) {
            //将查出来的每一条笔记高亮显示
            this.rendition.annotations.remove(item.textRange, "highlight");
            this.rendition.annotations.highlight(item.textRange, {}, (e) => {
              setTimeout(() => {
                console.log("将查出来的每一条笔记高亮显示");
                this.cfiRange = "";
                this.showAddNotes = false;
              }, 700);
            });
          }
        } else if (type == "bookmark") {
          this.bookmarkList = response.data;
        } else if (type == "lineation") {
          for (let item of response.data) {
            //将查出来的每一条笔记高亮显示
            this.rendition.annotations.remove(item.textRange, "highlight");
            this.rendition.annotations.highlight(
              item.textRange,
              {},
              (e) => {
                setTimeout(() => {
                  this.cfiRange = "";
                  this.showAddNotes = false;
                }, 700);
                this.$confirm("是否删除该划线标记?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }).then(() => {
                  this.rendition.annotations.remove(
                    item.textRange,
                    "highlight"
                  );
                  removeNoteById(item.id).then((response) => {
                    this.initNoteList("lineation");
                    this.$message({
                      type: "success",
                      message: "删除成功",
                    });
                  });
                  return false;
                });
              },
              "",
              { stroke: "red", "fill-opacity": 0 }
            );
          }
        }
        this.loading = false;
      });
    },
    getNoteList(type) {
      //查询笔记
      selectNoteListByFileId(this.filesId, type).then((response) => {
        if (type == "note") {
          this.highlights = response.data;
        } else if (type == "bookmark") {
          this.bookmarkList = response.data;
        }

        this.loading = false;
      });
    },

    notesBtn() {
      if (this.range) {
        this.note = {
          goodsId: this.goodsId,
          goodsFileId: this.filesId,
          originalText: this.range.toString(),
          textRange: this.cfiRange,
          href: "#" + this.cfiRange,
          noteContent: "",
          type: "note",
        };
        this.$prompt("请输入笔记内容", "提示", {
          inputType: "textarea",
          confirmButtonText: "确定",
          cancelButtonText: "取消",

          closeOnClickModal: false,
          inputValidator: (value) => {
            // 点击按钮时，对文本框里面的值进行验证
            if (!value || /^\s+$/.test(value)) {
              return "请输入笔记内容";
            }
            if (value.length > 100) {
              return "不能超过100字";
            }
          },
        })
          .then(({ value }) => {
            this.note.noteContent = value;
            let _this = this;
            //添加笔记内容
            insertNote(_this.note).then((res) => {
              if (res.code == 200) {
                _this.$message({
                  type: "success",
                  message: "操作成功",
                });
                _this.initNoteList("note");
                _this.bijivisible = true;
                _this.isRTL = true;
                this.cfiRange = "";

                _this.contents.window.getSelection().empty();
              }
              _this.showAddNotes = false;
            });
          })
          .catch(() => {
            this.rendition.annotations.remove(this.cfiRange, "highlight");
            this.cfiRange = "";
            this.isRTL = true;
            this.showAddNotes = false;
            this.contents.window.getSelection().empty();
          });
      }
    },
    lineationBtn() {
      if (this.range) {
        this.note = {
          goodsId: this.goodsId,
          goodsFileId: this.filesId,
          originalText: this.range.toString(),
          textRange: this.cfiRange,
          href: "#" + this.cfiRange,
          noteContent: "",
          type: "lineation",
          text: this.range.toString(),
        };
        //添加划线内容
        insertNote(this.note).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.initNoteList("lineation");
            this.isRTL = true;
            this.cfiRange = "";

            this.contents.window.getSelection().empty();
          }
          this.showAddNotes = false;
        });
      }
    },

    bookmarksBtn(type) {
      if (type === "add") {
        const currentLocation = this.rendition.currentLocation();
        const cfibase = currentLocation.start.cfi.replace(/!.*/, "");
        const cfistart = currentLocation.start.cfi
          .replace(/.*!/, "")
          .replace(/\)$/, "");
        const cfiend = currentLocation.end.cfi.replace(/.*!/, "");
        const cfirange = `${cfibase}!,${cfistart},${cfiend}`;
        this.book.getRange(cfirange).then((range) => {
          this.note = {
            goodsId: this.goodsId,
            goodsFileId: this.filesId,
            originalText: currentLocation.start.href,
            textRange: currentLocation.start.cfi,
            href: "#" + currentLocation.start.href,
            noteContent: range.toString(),
            type: "bookmark",
            text: range.toString().substring(0, 200),
          };
          //添加书签内容
          insertNote(this.note).then((res) => {
            this.$message({
              type: "success",
              message: "已加入书签",
            });
            this.initNoteList("bookmark");
          });
        });
      } else {
        const currentLocation = this.rendition.currentLocation();
        this.bookmarkList.map((item) => {
          if (item.noteContent == currentLocation.start.href) {
            this.deleteBookmark(item.id);
          }
        });
      }
    },

    deleteBookmark(id) {
      removeNoteById(id).then((response) => {
        this.initNoteList("bookmark");
        this.$message({
          type: "success",
          message: "已移除书签",
        });
      });
    },

    getMuluValue(href) {
      // for (let i = 0; i < this.mulu.length; i++) {
      //   if (this.mulu[i].href == href) {
      //     return this.mulu[i].label;
      //   } else if (this.mulu[i].subitems.length > 0) {
      //     for (let j = 0; j < this.mulu[i].subitems.length; i++) {
      //       if (this.mulu[i].subitems[j].href == href) {
      //         return this.mulu[i].subitems[j].label;
      //       }
      //     }
      //   }
      // }
      // return href;
    },
  },
};
</script>
<style scoped lang="scss">
#extras {
  /*  width: 600px;
margin: 40px auto;*/
  width: 600px;
  height: 100vh;
  /* overflow: auto; */
  margin: 0 auto;
}

.read_center_box > iframe {
  background: white;
  box-shadow: 0 0 4px #ccc;

  /*margin: 10px;
padding: 20px;*/
}

#viewer {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-bottom: 20px;
  box-shadow: 0 0 5px #848484;
  overflow: hidden;
  /*  !* overflow: auto; *!
margin: 0 auto;*/
}

#highlights {
  list-style: none;
  margin-left: 0;
  padding: 0;
}

#highlights li {
  list-style: none;
  margin-bottom: 20px;
  border-top: 1px solid #e2e2e2;
  padding: 10px;
}

#highlights a {
  display: block;
}

#viewer.spreads {
  top: 0;
  margin-top: 50px;
}

[ref="epubjs-mk"] {
  background: url("data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPScxLjEnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZycgeG1sbnM6eGxpbms9J2h0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsnIHg9JzBweCcgeT0nMHB4JyB2aWV3Qm94PScwIDAgNzUgNzUnPjxnIGZpbGw9JyNCREJEQkQnIGlkPSdidWJibGUnPjxwYXRoIGNsYXNzPSdzdDAnIGQ9J00zNy41LDkuNEMxOS42LDkuNCw1LDIwLjUsNSwzNC4zYzAsNS45LDIuNywxMS4zLDcuMSwxNS42TDkuNiw2NS42bDE5LTcuM2MyLjgsMC42LDUuOCwwLjksOC45LDAuOSBDNTUuNSw1OS4yLDcwLDQ4LjEsNzAsMzQuM0M3MCwyMC41LDU1LjQsOS40LDM3LjUsOS40eicvPjwvZz48L3N2Zz4=")
    no-repeat;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 0;
}

.epub_box {
  width: 100%;
  overflow: hidden;
  background: rgb(242, 242, 242);
  padding: 0 20px;
  box-sizing: border-box;
  min-height: 100vh;
}

.epub_box_c {
  width: 100%;
  display: table;
}

.read_left_box {
  width: 304px;
  float: left;
  margin-right: 15px;
}

.read_left {
  width: 100%;
  float: left;
  margin-bottom: 16px;
  padding: 15px;
  box-sizing: border-box;
}

.epub_box .bread {
  width: 100% !important;
}

.read_leftt1 {
  margin-top: 12px;
  margin-bottom: 12px;
}

.read_leftt1_img {
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto;
  box-shadow: 0 0 3px #ccc;
  margin-bottom: 14px;
}

.read_leftt1 > p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
}

.read_leftt1 > p span {
  border: 1px solid #0081ce;
  border-radius: 6px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #0081ce;
  line-height: 22px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 10px;
}

.read_leftt2 {
  width: 100%;
  overflow: hidden;
  padding: 0 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 10px;
}

.read_leftt2 li {
  list-style: none;
  width: 100%;
  float: left;
  font-size: 14px;
  margin-bottom: 8px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.read_leftt3 {
  width: 100%;
  float: left;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.read_left2 {
  width: 100%;
  float: left;
  margin-bottom: 16px;
  padding: 15px;
  box-sizing: border-box;
}

.read_left2 .theme-title::before {
  background: #f6a200;
}

.read_left2_ul {
  width: 100%;
  float: left;
  margin-top: 15px;
}

.read_left2_ul li {
  width: 100%;
  float: left;
  height: 46px;
  border-top: 1px solid #f2f2f2;
  list-style: none;
}

.read_left2_ul li p {
  font-size: 14px;
  float: left;
  width: calc(100% - 30px);
  cursor: pointer;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
  color: #333333;
}

.read_left2_ul li span {
  float: right;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
}

.read_left2_ul li span.mf {
  color: #2e9adb;
}

.read_left2_ul li span.ff {
  color: #ff5353;
}

.read_left2_ul li.active p {
  color: #2e9adb;
}

.read_center_box {
  float: left;
  width: calc(100% - 400px);
  min-height: 95vh;
  position: relative;
}

.read_right_box {
  float: right;
  width: 60px;
}

.read_right_box1 {
  width: 100%;
  float: left;
  position: relative;
}

.read_right_box1 li {
  list-style: none;
  width: 100%;
  height: 60px;
  float: left;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
}

.read_right_box1 li img {
  display: block;
  margin: 10px auto;
  height: 20px;
}

.read_right_box1 li p {
  font-size: 13px;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

.read_right_box2 {
  width: 100%;
  float: left;
  margin-top: 8px;
}

.read_right_box2 img {
  display: block;
  margin: 12px auto;
  cursor: pointer;
  width: 28px;
  background-color: #fff;
  border-radius: 50%;
}

.mulu {
  width: 100%;
  max-height: calc(100vh - 130px);
  float: left;
  /* padding: 15px 24px; */
  box-sizing: border-box;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
}
.bookmark-item {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.mulu::-webkit-scrollbar {
  width: 5px;
  /*height: 4px;*/
}

.mulu::-webkit-scrollbar-thumb {
  border-radius: 15px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #fbfbfb;
}

.mulu::-webkit-scrollbar-track {
  border-radius: 0;
}

.mulu > i {
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
}

.mulu > li {
  list-style: none;
  width: 100%;
  float: left;
  border-bottom: 1px dashed #ccc;
}

.rmulu li {
  cursor: pointer;
}

.mulu > li > p {
  width: 100%;
  float: left;
  font-size: 13px;
  font-family: PingFang SC;
  padding-bottom: 5px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  margin-top: 5px;
}

.twomulu {
  margin-left: 10px;
}

.twomulu > li {
  width: 100%;
  list-style: outside;
  float: left;
  font-size: 13px;
  font-family: PingFang SC;
  border-bottom: 1px dashed #ccc;
  margin-bottom: 5px;
  padding-bottom: 5px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}

.mulu_liright {
  float: right;
}

.mulu_liright span {
  margin-left: 8px;
  cursor: pointer;
}

.shezhi {
  width: 100%;
  float: left;
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
}

.shezhi > i {
  position: absolute;
  right: 0px;
  top: -10px;
  cursor: pointer;
}

.shezhi li {
  width: 100%;
  float: left;
  list-style: none;
  margin-bottom: 30px;
}

.shezhi li p {
  float: left;
  font-size: 13px;
  height: 21px;
  line-height: 21px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
}

.xz_box {
  width: calc(100% - 80px);
  margin-left: 15px;
  float: left;
  height: 21px;
}

.shezhi li:last-child {
  margin-bottom: 0;
}

.ydzt span {
  width: 22px;
  height: 22px;
  float: left;
  border: 1px solid #999999;
  border-radius: 50%;
  margin-right: 10px;
  cursor: pointer;
}

.ydzt span.active {
  border: 1px solid red;
}

.ydzt span.active:before {
  content: "√";
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 22px;
  color: red;
  display: block;
}

.zwzt span {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 21px;
  margin-right: 10px;
  cursor: pointer;
}

.zwzt span.active {
  color: #0081ce;
}

.ztdx .el-input-number {
  margin-top: -4px;
}

.shezhi_button {
  display: table;
  margin: 20px auto 0;
}

.shezhi_button span {
  width: 80px;
  cursor: pointer;
  float: left;
  border: 1px solid #2e9adb;
  text-align: center;
  line-height: 24px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #2e9adb;
  height: 24px;
  background: #fff;
  border-radius: 6px;
  margin-right: 30px;
}

.shezhi_button span:last-child {
  margin-right: 0;
}

.shezhi_button span:first-child {
  background: #2e9adb;
  color: #fff;
}

.color_hei .read_left {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_left2 {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_right_box1 {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_center_box {
  background: rgba(255, 255, 255, 0.2);
}

.color_hei .read_leftt1 > p {
  color: #ccc;
}

.color_hei .read_leftt2 li {
  color: #ccc;
}

.color_hei .read_leftt3 {
  color: #ccc;
}

.color_hei .theme-title {
  color: #ccc;
}

.color_hei .read_left2_ul li p {
  color: #ccc;
}

.color_hei .read_right_box1 li p {
  color: #ccc;
}

.read_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .bookmarks {
    padding-top: 10px;
    img {
      width: 30px;
      cursor: pointer;
    }
  }
}
.dqyd {
  line-height: 35px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}

.dqyd img {
  float: left;
  width: 12px;
  margin-top: 12px;
  margin-right: 5px;
}

/* 默认 */
.zt_moren {
  background: #e6e1d5;
  position: relative;
}

.zt_moren .read_left {
  background: #f5f1e8;
}

.zt_moren .read_left2 {
  background: #f5f1e8;
}

.zt_moren .read_right_box1 {
  background: #f5f1e8;
}

.zt_moren .read_center_box {
  background: #f5f1e8;
}

.zt_moren .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_moren .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_moren .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 牛皮纸 */
.zt_niupizhi {
  background: #dbcfa5;
}

.zt_niupizhi .read_left {
  background: #efe7c9;
}

.zt_niupizhi .read_left2 {
  background: #efe7c9;
}

.zt_niupizhi .read_right_box1 {
  background: #efe7c9;
}

.zt_niupizhi .read_center_box {
  background: #efe7c9;
}

.zt_niupizhi .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_niupizhi .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_niupizhi .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 淡绿色 */
.zt_danlvse {
  background: #d2e0d0;
}

.zt_danlvse .read_left {
  background: #e6f0e6;
}

.zt_danlvse .read_left2 {
  background: #e6f0e6;
}

.zt_danlvse .read_right_box1 {
  background: #e6f0e6;
}

.zt_danlvse .read_center_box {
  background: #e6f0e6;
}

.zt_danlvse .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_danlvse .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_danlvse .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 淡蓝色 */
.zt_danlanse {
  background: #d2dcdc;
}

.zt_danlanse .read_left {
  background: #e6f0f0;
}

.zt_danlanse .read_left2 {
  background: #e6f0f0;
}

.zt_danlanse .read_right_box1 {
  background: #e6f0f0;
}

.zt_danlanse .read_center_box {
  background: #e6f0f0;
}

.zt_danlanse .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_danlanse .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_danlanse .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 淡粉色 */
.zt_danfense {
  background: #e6cfcf;
}

.zt_danfense .read_left {
  background: #f0e5e5;
}

.zt_danfense .read_left2 {
  background: #f0e5e5;
}

.zt_danfense .read_right_box1 {
  background: #f0e5e5;
}

.zt_danfense .read_center_box {
  background: #f0e5e5;
}

.zt_danfense .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_danfense .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_danfense .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 灰色 */
.zt_huise {
  background: #d4d4d4;
}

.zt_huise .read_left {
  background: #dadada;
}

.zt_huise .read_left2 {
  background: #dadada;
}

.zt_huise .read_right_box1 {
  background: #dadada;
}

.zt_huise .read_center_box {
  background: #dadada;
}

.zt_huise .read_leftt2 {
  border-color: #d9d9d9;
}

.zt_huise .read_right_box1 li {
  border-color: #d9d9d9;
}

.zt_huise .read_left2_ul li {
  border-color: #d9d9d9;
}

/* 黑色 */
.zt_heise {
  background: #000;
}

.zt_heise .read_left {
  background: #424242;
}

.zt_heise .read_left2 {
  background: #424242;
}

.zt_heise .read_right_box1 {
  background: #424242;
}

.zt_heise .read_center_box {
  background: #424242;
}

.zt_heise .read_leftt2 {
  border-color: #fff;
}

.zt_heise .read_right_box1 li {
  border-color: #fff;
}

.zt_heise .read_left2_ul li {
  border-color: #fff;
}

.zt_heise .theme-title {
  color: #fff;
}

.zt_heise .read_leftt1 > p {
  color: #fff;
}

.zt_heise .read_leftt2 li {
  color: #fff;
}

.zt_heise .read_leftt3 {
  color: #fff;
}

.zt_heise .read_left2_ul li p {
  color: #fff;
}

.zt_heise .read_right_box1 li p {
  color: #fff;
}

#divider {
  position: absolute;
  width: 1px;
  border-right: 1px #000 solid;
  height: 90%;
  z-index: 1;
  left: 50%;
  margin-left: -1px;
  top: 6%;
  opacity: 0.15;
  box-shadow: -2px 0 15px rgba(0, 0, 0, 1);
}

.slider_box {
  position: absolute;
  width: 98%;
  bottom: 0;
  opacity: 0.4;
}

.slider_box:hover {
  opacity: 1;
}

::v-deep .bread {
  width: 100% !important;
}

::v-deep .epub-container::-webkit-scrollbar {
  width: 5px;
  /*height: 4px;*/
}

::v-deep .epub-container::-webkit-scrollbar-thumb {
  border-radius: 15px;
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3); */
  /* background: #fbfbfb; */
  background: rgba(144, 147, 153, 0.3);
}

::v-deep .epub-container::-webkit-scrollbar-thumb:hover {
  background: rgba(144, 147, 153, 0.5);
}

::v-deep .epub-container::-webkit-scrollbar-track {
  border-radius: 0;
}

.sjcz {
  width: 100%;
  float: left;
  margin-bottom: 10px;
}

.sjcz p {
  float: left;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.cursorDefault {
  cursor: default !important;
}
.content-search-text {
  color: #2e9adb;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
}
.searchList_box {
  padding: 10px 5px;
  border-bottom: 1px dashed #cccccc;
  cursor: pointer;
}
.search_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  .searchbox {
    width: 80px;
    height: 32px;
    background: #2e9adb;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    color: #ffffff;
  }
}

.custom-search {
  width: 480px;
}
.custom-input {
  width: 420px;
  position: relative;
  right: 50px;
}

.add-notes-bookmarks-pc {
  position: absolute;
  // left: 48%;
  z-index: 99999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90px;
  padding: 5px;
  box-sizing: border-box;
  background: #2b2b2b;
  border-radius: 6px;

  .item-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 999999;

    img {
      width: 20px;
      cursor: pointer;
    }

    span {
      font-size: 12px;
      color: #ffffff;
    }
  }
}
</style>
